import React, { useEffect } from "react";
import { logCaseVisit } from "../../services/api";

const Ecology2 = () => {
  useEffect(() => {
    logCaseVisit("AIR_POLLUTION").catch((error) => {
      console.error(
        "Не удалось залогировать посещение кейса AIR_POLLUTION",
        error,
      );
    });
  }, []);

  return (
    <iframe
      src="https://iframe.iteamsolutions.kz/ecology1"
      title="ecology1"
      style={{ border: "none" }}
      width="100%"
      height="100%"
    />
  );
};

export default Ecology2;
